<template>
  <div class="pwc-qrcode-item" @click="handlePreview">
    <van-image
      v-if="event.checkinQrCodeUrl"
      :src="event.checkinQrCodeUrl"
    />
    <van-cell-group :border="false">
      <van-cell :title="cTitle" icon="star-o" />
      <van-cell :title="cDate | dateYMD" icon="clock-o" />
      <van-cell :title="cAddress" icon="location-o" />
    </van-cell-group>
  </div>
</template>

<script>
import { Image, CellGroup, Cell, ImagePreview } from 'vant'

export default {
  components: {
    VanImage: Image,
    VanCellGroup: CellGroup,
    VanCell: Cell
  },
  props: {
    event: {
      type: Object,
      default: () => { return {} }
    }
  },
  computed: {
    cTitle() {
      return this.event.eventName
    },
    cDate() {
      return this.event.startTime
    },
    cAddress() {
      return this.event.location
    }
  },
  methods: {
    handlePreview() {
      if (this.event.checkinQrCodeUrl) {
        ImagePreview([this.event.checkinQrCodeUrl])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-qrcode-item {
    word-break: break-all;
    width: 100%;
    >img {
        width: 100%;
    }
}
</style>
